// Étapes occupées d'un pipeline : nombre d'affaires par étape, affiché dans les réglages pour qu'on sache avant
// d'enregistrer qu'une étape ne peut pas être retirée (la base le refuse de toute façon, spec § 11).
import type { DealStage } from "../types";

/** Nombre d'affaires par code d'étape, archivées comprises (la base les compte aussi). */
export const stageCounts = (
  deals: { stage?: string | null; archived_at?: string | null }[],
) => {
  const counts: Record<string, number> = {};
  for (const deal of deals)
    if (deal.stage) counts[deal.stage] = (counts[deal.stage] ?? 0) + 1;
  return counts;
};

/** Étapes retirées encore occupées, nommées comme on les voit : « Rendez-vous » (2), … ; vide si aucune. */
export const stagesInUse = (
  values: string[],
  stages: DealStage[],
  counts: Record<string, number>,
) =>
  values
    .filter((value) => counts[value])
    .map(
      (value) =>
        `« ${stages.find((s) => s.value === value)?.label ?? value} » (${counts[value]})`,
    )
    .join(", ");
